// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2HFrq","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3z4eW"};